import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'vtr-material-slider',
	templateUrl: './material-slider.component.html',
	styleUrls: ['./material-slider.component.scss'],
})
export class MaterialSliderComponent {
	@Input() sliderId: string;
	@Input() min: number = minValue;
	@Input() max: number = maxValue;
	@Input() step: number = 1;
	@Input() value: number = minValue;
	@Input() disabled: boolean = false;
	@Input() legends: Array<{ id: string; value: string }> = [];
	@Input() showThumbLabel: boolean = false;
	@Input() displayWithK: boolean = false;

	@Output() readonly inputChange: EventEmitter<number> = new EventEmitter<number>();
	@Output() readonly valueChange: EventEmitter<number | null> = new EventEmitter<number | null>();

	public onInput($event: { value: number }) {
		this.inputChange.emit($event.value);
	}

	public onValueChange(value: number) {
		this.valueChange.emit(value);
	}

	sliderLabelDisplayWith = (value) => {
		if (this.displayWithK) {
			var element = document.getElementById(this.sliderId + '-slider');
			element.classList.add('thumb-label-with-k');
			return value + 'K';
		}
		return value;
	};
}

const minValue = 0;
const maxValue = 100;
